import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/login',
    meta: { title: 'Login', noCache: true },
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        component: (resolve) => require(['@/views/home'], resolve),
        name: 'Dashboard'
        // meta: { title: '首页', icon: 'index', affix: true, noCache: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

export default router
